// ── OnboardingChecklist — first week progress card ────────────────────────
import { useState } from 'react';
import { useTr } from '../utils/useTr';
import { useApp } from '../contexts/AppContext';
import { getOnboardingProgress } from '../utils/onboarding';

export default function OnboardingChecklist({ compact = false, onNavigate }) {
  const tr = useTr();
  const { currentUser, lang, features } = useApp();
  const [expanded, setExpanded] = useState(!compact);
  const progress = getOnboardingProgress(currentUser || {}, {}, features);

  if (progress.allDone) return null;

  const G = {
    gold:'var(--gold)', goldPale:'var(--gold-pale)', goldBdr:'var(--gold-border)',
    border:'var(--border)', card:'var(--dark)', muted:'var(--muted)', white:'var(--white)',
    green:'#4EC994', sans:"'Outfit',sans-serif",
  };

  const DESTINATIONS = {
    photo:     'profile',
    quiz:      'profile',
    bio:       'profile',
    interests: 'profile',
    verify:    'profile',
    invite:    'profile',
    like:      'discover',
  };

  return (
    <div style={{ background:G.goldPale, border:`1px solid ${G.goldBdr}`, borderRadius:12, overflow:'hidden', marginBottom:'1rem' }}>
      {/* Header */}
      <div onClick={() => setExpanded(e => !e)}
        style={{ display:'flex', alignItems:'center', gap:'0.7rem', padding:'0.8rem 1rem', cursor:'pointer' }}>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:'0.72rem', fontWeight:700, color:G.gold, marginBottom:'0.2rem' }}>
            {lang === 'fr' ? 'Complète ton profil' : 'Complete your profile'}
            <span style={{ marginLeft:'0.4rem', fontSize:'0.65rem', color:G.muted, fontWeight:400 }}>
              {progress.completed}/{progress.total}
            </span>
          </div>
          <div style={{ height:3, background:'rgba(201,168,76,0.15)', borderRadius:2, overflow:'hidden' }}>
            <div style={{ height:'100%', width:`${progress.pct}%`, background:G.gold, borderRadius:2, transition:'width 0.4s' }}/>
          </div>
        </div>
        <span style={{ color:G.muted, fontSize:'0.7rem' }}>{expanded ? '▲' : '▼'}</span>
      </div>

      {/* Steps */}
      {expanded && (
        <div style={{ borderTop:`1px solid ${G.goldBdr}` }}>
          {progress.steps.map((step, i) => (
            <div
              key={step.id}
              onClick={() => !step.done && onNavigate?.(DESTINATIONS[step.id])}
              style={{
                display:'flex', alignItems:'center', gap:'0.7rem',
                padding:'0.6rem 1rem',
                borderBottom: i < progress.steps.length - 1 ? `1px solid ${G.goldBdr}` : 'none',
                opacity: step.done ? 0.6 : 1,
                cursor: step.done ? 'default' : 'pointer',
                background: !step.done && progress.nextStep?.id === step.id ? 'rgba(201,168,76,0.06)' : 'transparent',
              }}>
              <div style={{ width:28, height:28, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', background: step.done ? 'rgba(78,201,148,0.15)' : G.goldPale, border:`1px solid ${step.done ? 'rgba(78,201,148,0.4)' : G.goldBdr}`, flexShrink:0, fontSize:'0.8rem' }}>
                {step.done ? '✓' : step.icon}
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:'0.75rem', color: step.done ? G.muted : G.white, fontWeight: step.done ? 400 : 600, textDecoration: step.done ? 'line-through' : 'none' }}>
                  {lang === 'fr' ? step.labelFR : step.label}
                </div>
                {!step.done && (
                  <div style={{ fontSize:'0.62rem', color:G.gold, marginTop:'0.1rem' }}>
                    ✦ {lang === 'fr' ? step.rewardFR : step.reward}
                  </div>
                )}
              </div>
              {!step.done && (
                <span style={{ fontSize:'0.65rem', color:G.gold }}>→</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
